import React from 'react';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import WorkSchedule from '../../components/workSchedule/WorkSchedule';

class WorkScheduleContainer extends React.Component {
  render() {
    return (
      <Row>
        <Col>
          <WorkSchedule match={this.props.match} history={this.props.history} />
        </Col>
      </Row>
    );
  }
}

export default WorkScheduleContainer;
